import React from "react";
import amenities1A from "../PicsForPages/amenities1A.webp";
import amenities1B from "../PicsForPages/amenities1B.webp";
import amenities1C from "../PicsForPages/amenities1C.webp";
// import amenities2A from "../PicsForPages/amenities2A.webp";
// import amenities2B from "../PicsForPages/amenities2B.webp";
// import amenities2C from "../PicsForPages/amenities2C.webp";
import amenities2A from "../PicsForPages/amenities2A.png";
import amenities2B from "../PicsForPages/amenities2B.png";
import amenities2C from "../PicsForPages/amenities2C.png";
import UseScrollAnimation from "../Elements/ScrollAnimation";

function Amenities() {
  UseScrollAnimation(); // ✅ just call it

  return (
    <div className="LocalInformationParent">
      <div className="LocalInformationBox">
        <div className="LocalInformationBoxHeading">
          <span className="LocalInformationBoxHeadingWord animate-top">
            Amenities
          </span>
          <span className="LocalInformationBoxHeadingLine animate-top"></span>
        </div>
        <div className="AmenitiesBoxImagesDiv">
          <img
            fetchPriority="high"
            loading="eager"
            src={amenities1A}
            alt="AmenitiesBoxImages01"
            className="AmenitiesBoxImages animate-top"
          />
          <img
            fetchPriority="high"
            loading="eager"
            src={amenities1B}
            alt="AmenitiesBoxImages02"
            className="AmenitiesBoxImages animate-top"
          />
          <img
            fetchPriority="high"
            loading="eager"
            src={amenities1C}
            alt="AmenitiesBoxImages03"
            className="AmenitiesBoxImages animate-top"
          />
        </div>
        <div className="LocalInformationBoxContentBoxLine AmenitiesBoxContentBoxLine">
          <div className="LocalInformationBoxContentBoxLinePara animate-top">
            Finding a home that complements your lifestyle is paramount, and at
            Cornelius Woods, we understand this deeply. Offering a variety of
            one, two, or three-bedroom floor plans, our homes are designed to
            not only meet but exceed your expectations. And yet, despite the
            high standard of living they provide, they represent incredible
            value.
          </div>
          <div className="LocalInformationBoxContentBoxLinePara animate-top">
            Our homes are meticulously crafted with the finest finishes and
            features that reflect your taste for elegance and sophistication.
            Stainless steel appliances lend a modern aesthetic to your kitchen,
            while quartz countertops add a touch of luxury. The master baths are
            fitted with designer tile shower walls (per plan), bringing an
            element of spa-like tranquility to your private space.
          </div>
          <div className="LocalInformationBoxContentBoxLinePara animate-top">
            However, it's the unwavering attention to detail that truly sets
            Cornelius Woods apart. Every feature, every finish, has been
            thoughtfully chosen to create a sense of warmth, style, and comfort,
            making your home more than just a place to live. It becomes a
            statement of your lifestyle, a testament to your discerning eye for
            quality.
          </div>
          <div className="LocalInformationBoxContentBoxLinePara animate-top">
            Welcome to Cornelius Woods, where every detail is a reflection of
            our commitment to delivering an unparalleled living experience. Make
            one of these exceptional homes your own, and embrace the luxurious
            lifestyle you've always aspired to.
          </div>
        </div>
        <div className="LocalInformationBoxContentBoxLine">
          <div className="LocalInformationBoxHeading">
            <span className="LocalInformationBoxHeadingWord animate-top">
              Finishes & Features
            </span>
            <span className="LocalInformationBoxHeadingLine animate-top"></span>
          </div>
          <div className="LocalInformationBoxContentBox">
            <div className="LocalInformationBoxContentBoxLine">
              <div className="LocalInformationBoxContentBoxLineHeading animate-top">
                Beautiful Architectural Design with Brick Exterior
              </div>
              <div className="LocalInformationBoxContentBoxLinePara animate-top">
                Immerse yourself in the timeless beauty of Cornelius Woods,
                where the impressive brick exterior pays homage to classic
                architectural design while embodying an unmistakable touch of
                modern elegance.
              </div>
            </div>
            <div className="LocalInformationBoxContentBoxLine">
              <div className="LocalInformationBoxContentBoxLineHeading animate-top">
                Private Balconies
              </div>
              <div className="LocalInformationBoxContentBoxLinePara animate-top">
                Every residence at Cornelius Woods comes with a private balcony.
                This outdoor retreat is the perfect spot to savor your morning
                coffee or unwind in the evening, enjoying the serenity of our
                beautifully landscaped surroundings.
              </div>
            </div>
            <div className="LocalInformationBoxContentBoxLine">
              <div className="LocalInformationBoxContentBoxLineHeading animate-top">
                9' Ceilings
              </div>
              <div className="LocalInformationBoxContentBoxLinePara animate-top">
                Our homes feature 9' ceilings that add a sense of grandeur and
                openness to your living space. High ceilings not only enhance
                the visual appeal but also create a bright and airy environment
                that is both comfortable and inviting.
              </div>
            </div>
            <div className="LocalInformationBoxContentBoxLine">
              <div className="LocalInformationBoxContentBoxLineHeading animate-top">
                Modern Shaker Style Cabinets with Soft-Close Hardware
              </div>
              <div className="LocalInformationBoxContentBoxLinePara animate-top">
                The modern shaker-style cabinets fitted with soft-close hardware
                infuse a contemporary appeal into your kitchen and baths. These
                finely crafted cabinets combine practicality and style, ensuring
                that your storage solutions are as visually pleasing as they are
                functional.
              </div>
            </div>
            <div className="LocalInformationBoxContentBoxLine">
              <div className="LocalInformationBoxContentBoxLineHeading animate-top">
                Quartz Countertops in Kitchen and Baths
              </div>
              <div className="LocalInformationBoxContentBoxLinePara animate-top">
                Our homes boast quartz countertops in both the kitchen and
                bathrooms, imparting a sleek, polished aesthetic. Quartz is not
                only stunning to look at, but it's also durable and easy to
                maintain, making it a perfect choice for these high-use areas.
              </div>
            </div>
            <div className="LocalInformationBoxContentBoxLine">
              <div className="LocalInformationBoxContentBoxLineHeading animate-top">
                Energy Efficient Heat Pump
              </div>
              <div className="LocalInformationBoxContentBoxLinePara animate-top">
                Stay comfortable year-round with our energy-efficient heat
                pumps. These units offer both heating and cooling, helping to
                keep your home at the perfect temperature while also reducing
                energy consumption.
              </div>
            </div>
            <div className="LocalInformationBoxContentBoxLine">
              <div className="LocalInformationBoxContentBoxLineHeading animate-top">
                Dual Master Vanity with Modern, Rectangular Undermount Sinks
              </div>
              <div className="LocalInformationBoxContentBoxLinePara animate-top">
                Experience the luxury of a dual master vanity fitted with
                modern, rectangular undermount sinks. This thoughtful feature
                amplifies functionality and adds a touch of elegance to your
                bathroom routine.
              </div>
            </div>
            <div className="LocalInformationBoxContentBoxLine">
              <div className="LocalInformationBoxContentBoxLineHeading animate-top">
                Walk-In Shower with Glass Doors (per plan)
              </div>
              <div className="LocalInformationBoxContentBoxLinePara animate-top">
                Step into relaxation with our walk-in showers featuring glass
                doors (per plan). These beautifully designed spaces elevate your
                bathroom, turning daily rituals into moments of indulgence.
              </div>
            </div>
            <div className="LocalInformationBoxContentBoxLine">
              <div className="LocalInformationBoxContentBoxLineHeading animate-top">
                LVP Flooring
              </div>
              <div className="LocalInformationBoxContentBoxLinePara animate-top">
                Our homes feature Luxury Vinyl Plank (LVP) flooring, known for
                its durability and stunning aesthetics. With the look and feel
                of hardwood, but easier maintenance, LVP flooring combines style
                and practicality.
              </div>
            </div>
            <div className="LocalInformationBoxContentBoxLine">
              <div className="LocalInformationBoxContentBoxLineHeading animate-top">
                Black Kwikset® Door Hardware
              </div>
              <div className="LocalInformationBoxContentBoxLinePara animate-top">
                Every detail matters at Cornelius Woods, including our sleek,
                black Kwikset® door hardware. This brand is known for its
                security and durability, ensuring that every entry point in your
                home is reliable and stylish.
              </div>
            </div>
            <div className="LocalInformationBoxContentBoxLine">
              <div className="LocalInformationBoxContentBoxLineHeading animate-top">
                Stainless Steel Appliances
              </div>
              <div className="LocalInformationBoxContentBoxLinePara animate-top">
                Our kitchens are outfitted with state-of-the-art stainless steel
                appliances, offering a modern, polished look while ensuring
                optimal performance for your cooking adventures.
              </div>
            </div>
            <div className="LocalInformationBoxContentBoxLine">
              <div className="LocalInformationBoxContentBoxLineHeading animate-top">
                Washer/Dryer Included
              </div>
              <div className="LocalInformationBoxContentBoxLinePara animate-top">
                For your convenience, each home comes equipped with a washer and
                dryer, simplifying your laundry routine and adding to the
                comprehensive suite of appliances in your home.
              </div>
            </div>
            <div className="LocalInformationBoxContentBoxLine">
              <div className="LocalInformationBoxContentBoxLineHeading animate-top">
                Delta® Plumbing Fixtures
              </div>
              <div className="LocalInformationBoxContentBoxLinePara animate-top">
                We use top-of-the-line Delta® plumbing fixtures throughout our
                homes, ensuring that quality and durability accompany style in
                every facet of your home. These fixtures represent the standard
                of excellence that Cornelius Woods upholds across all our
                offerings.
              </div>
            </div>
          </div>
        </div>
        <div className="AmenitiesBoxImagesDiv">
          <img
            fetchPriority="high"
            loading="eager"
            src={amenities2A}
            alt="AmenitiesBoxImages01"
            className="AmenitiesBoxImages animate-top"
          />
          <img
            fetchPriority="high"
            loading="eager"
            src={amenities2B}
            alt="AmenitiesBoxImages02"
            className="AmenitiesBoxImages animate-top"
          />
          <img
            fetchPriority="high"
            loading="eager"
            src={amenities2C}
            alt="AmenitiesBoxImages03"
            className="AmenitiesBoxImages animate-top"
          />
        </div>
        <div className="LocalInformationBoxContentBoxLine">
          <div className="LocalInformationBoxHeading">
            <span className="LocalInformationBoxHeadingWord animate-top">
              Exterior Amenities
            </span>
            <span className="LocalInformationBoxHeadingLine animate-top"></span>
          </div>
          <div className="LocalInformationBoxContentBox">
            <div className="LocalInformationBoxContentBoxLine">
              <div className="LocalInformationBoxContentBoxLineHeading animate-top">
                Fenced Dog Park
              </div>
              <div className="LocalInformationBoxContentBoxLinePara animate-top">
                Embrace a unique community that understands and values your
                beloved pets as much as you do. At Cornelius Woods, we offer a
                secure, fenced Dog Park – a haven where your furry friends can
                roam free and socialize with other pets. Tail-wagging adventures
                await in this beautifully maintained, expansive green space.
              </div>
            </div>
            <div className="LocalInformationBoxContentBoxLine">
              <div className="LocalInformationBoxContentBoxLineHeading animate-top">
                Walking Trail
              </div>
              <div className="LocalInformationBoxContentBoxLinePara animate-top">
                Recharge, rejuvenate, and reconnect with nature on our
                enchanting Walking Trail. Nestled amidst lush, green
                surroundings, the trail offers you the perfect setting for
                tranquil morning strolls or invigorating evening walks. Witness
                the blend of wellness and scenic beauty, right at your doorstep.
              </div>
            </div>
            <div className="LocalInformationBoxContentBoxLine">
              <div className="LocalInformationBoxContentBoxLineHeading animate-top">
                Pickleball Courts
              </div>
              <div className="LocalInformationBoxContentBoxLinePara animate-top">
                Stay active and enjoy friendly competition on our
                state-of-the-art Pickleball Courts. Whether you're a seasoned
                player or a curious newbie, these courts promise exhilarating
                games, a lively community spirit, and a fantastic way to
                maintain your fitness goals.
              </div>
            </div>
            <div className="LocalInformationBoxContentBoxLine">
              <div className="LocalInformationBoxContentBoxLineHeading animate-top">
                Garden Space and Fire Pit
              </div>
              <div className="LocalInformationBoxContentBoxLinePara animate-top">
                At Cornelius Woods, luxury meets comfort and nature. Enjoy the
                tranquility of our shared Garden Space, a serene escape where
                you can cultivate your green thumb or simply relish the
                serenity. As the day ends, gather around the cozy Fire Pit.
                Share stories, make memories, and experience the warmth of the
                community under the starlit sky.
              </div>
            </div>
            <div className="LocalInformationBoxContentBoxLine">
              <div className="LocalInformationBoxContentBoxLineHeading animate-top">
                Electric Vehicle Charging
              </div>
              <div className="LocalInformationBoxContentBoxLinePara animate-top">
                We understand the importance of sustainable living. To cater to
                our eco-conscious residents, Cornelius Woods provides Electric
                Vehicle Charging stations. You can conveniently power your
                electric vehicles within the premises, thus promoting a greener,
                cleaner, and more sustainable future.
              </div>
            </div>
            <div className="LocalInformationBoxContentBoxLine">
              <div className="LocalInformationBoxContentBoxLineHeading animate-top">
                Covered Parking
              </div>
              <div className="LocalInformationBoxContentBoxLinePara animate-top">
                Every detail at Cornelius Woods is designed with your
                convenience in mind. Our Covered Parking facility ensures your
                vehicles are protected from the elements at all times. Easy to
                access and secure, we've taken care of the smallest details to
                offer you peace of mind and an unrivaled living experience.
              </div>
            </div>
          </div>
        </div>
        <div className="LocalInformationBoxContentBoxLine AmenitiesBoxContentBoxLine">
          <div className="LocalInformationBoxHeading">
            <span className="LocalInformationBoxHeadingLine animate-top"></span>
          </div>
          <div className="LocalInformationBoxContentBoxLinePara animate-top">
            At Cornelius Woods, our commitment to quality is evident in every
            finish, feature, and exterior amenity. We strive to create an
            environment that complements your lifestyle and reflects your
            discerning taste. Our luxurious homes, adorned with modern
            amenities, combined with the charm of our beautifully designed
            exteriors offer an unparalleled living experience. Every detail,
            from the private balconies and high ceilings to the energy-efficient
            appliances and stylish fixtures, is thoughtfully selected to bring
            elegance, comfort, and functionality into your home.
          </div>
          <div className="LocalInformationBoxContentBoxLinePara animate-top">
            Moreover, the expansive outdoor amenities invite you to embrace an
            active and sociable lifestyle. Whether you're spending a sunny
            afternoon at the dog park, enjoying a game at the pickleball courts,
            or savoring quiet moments in the garden space, you'll find an array
            of activities to engage and delight.
          </div>
          <div className="LocalInformationBoxContentBoxLinePara animate-top">
            At Cornelius Woods, we're not just building homes; we're crafting
            lifestyles. Discover the elegance of meticulous design, the pleasure
            of top-tier amenities, and the joy of a vibrant community. Welcome
            to a place that's more than a home — it's a lifestyle.
          </div>
        </div>
      </div>
    </div>
  );
}

export default Amenities;
